function SummaryNoRecordFound() {

    return (
        <div className="d-flex align-items-center justify-content-center p-5 flex-column">
            <img
                className="no-record-img"
                src="../images/no-record.gif"
                alt="No reord"
            />
            {/* <img src="../images/no-record.svg" alt="no-record"> */}
            <p className="font-medium font-20 mb-0 mt-3 text-center"
                style={{ fontWeight: "bold" }}>
                Oops! No Data Yet!
            </p>
            <p className="font-medium font-20 color-grey-v1 mb-0 mt-2 text-center">
                Looks like the numbers are on vacation!
            </p>
            <p className="font-medium font-20 color-grey-v1 mb-0 mt-2 text-center">
                Once they're back, we'll fill this dashboard right up
            </p>
        </div>
    )
}

export default SummaryNoRecordFound;